import React, { Fragment, useContext } from 'react'
import { navigate } from 'gatsby'
import './src/static/styles/global.css'
import 'github-markdown-css'
import 'react-image-crop/dist/ReactCrop.css'
import GlobalProvider, { setLoginInfo } from './src/context/globalContext'
import config from './src/config'
import menuMap from './src/layout/menus'
import tremApi from './src/util/tremApi'

export const onInitialClientRender = async () => {
    try {
        // www 리다이렉트 처리
        const location = window.location.href
        const reUrl = config.serverUrl + config.serverPrefixUrl

        if (process.env.env_name === 'production') {
            if(!location.includes("www") && reUrl.includes("seoulbiohub")){
                window.location.replace(reUrl)
            }
        }

        const rslt = await tremApi('/session/info/load/make/session', {}, () => {}).then(obj => {
            return obj
        })

        const {
            USER_SKEY,
            LOGIN_ID,
            NAME,
            ENG_NAME,
            COMPANY_SKEY,
            COMPANY_NAME,
            DEPT_SKEY,
            DEPT_NAME,
            JOIN_TYPE,
            loggined,
            auths,
        } = rslt.UserInfo

        if (rslt.sucess == 'S' && loggined) {
            setLoginInfo({
                loggined,
                USER_SKEY,
                LOGIN_ID,
                NAME,
                ENG_NAME,
                COMPANY_SKEY,
                COMPANY_NAME,
                DEPT_SKEY,
                DEPT_NAME,
                JOIN_TYPE,
                auths,
            })
        } else {
            setLoginInfo({
                loggined,
                USER_SKEY,
                LOGIN_ID,
                NAME,
                ENG_NAME,
                COMPANY_SKEY,
                COMPANY_NAME,
                DEPT_SKEY,
                DEPT_NAME,
                JOIN_TYPE,
                auths: config.applyAuthMenu ? auths : { menuMap },
                // avatarImage,
            })
        }
    } catch (err) {
        console.log(err)
    }
}

export const wrapRootElement = ({ element }) => {
    return <GlobalProvider>{element}</GlobalProvider>
}
